import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    CREDIT_APP_BUTTON_CONTINUE,
    PAYMENT_INFORMATION_DETAILS_BUTTONS_EDIT,
} from '../../../../../localization/resouceKeys';
import './style.scss';

interface IProps {
    children: any;
    title: string;
    handlerSubmit: Function;
    isOpen?: boolean;
    setOpen?: any;
    showIcon: boolean | null;
    isDisabled?: boolean;
    onEdit?: Function;
    isBlocked?: boolean;
    showPrint?: boolean;
    isFormValid?: boolean;
}

const FormSectionPage: React.FC<IProps> = ({
    children,
    title,
    handlerSubmit,
    isOpen = false,
    setOpen,
    showIcon,
    isDisabled = false,
    onEdit,
    isBlocked = false,
    isFormValid = false,
}: any) => {
    const { t } = useTranslation();
    return (
        <section
            className={`c-form-section  js-form-section ${
                isOpen ? 'is-open' : ''
            } ${
                showIcon !== null
                    ? showIcon
                        ? 'c-form-section--success'
                        : 'c-form-section--error'
                    : ''
            }`}
        >
            <button
                className='c-form-section__header  js-form-section__header'
                aria-expanded={`${!isOpen ? 'false' : 'true'}`}
                onClick={() => {
                    setOpen(!isOpen);
                }}
                disabled={isBlocked}
            >
                <span className='c-form-section__header-content'>
                    <span className='c-form-section__title  js-form-section__trigger'>
                        <span
                            className='c-form-section__title-text form-section__title-font'
                            role='heading'
                        >
                            {title}
                        </span>
                    </span>
                </span>
                {showIcon !== null ? (
                    <span className='c-form-section__header-icon'></span>
                ) : null}
            </button>

            <div
                className={`c-form-section__panel  js-form-section__panel ${
                    isOpen ? 'is-expanded' : ''
                }`}
                aria-hidden={!isOpen}
                hidden={!isOpen}
            >
                <div className='c-form-section__content'>
                    <form className='js-floating-label  ' action='#0'>
                        <fieldset className='o-fieldset'>{children}</fieldset>
                        <div className='o-fieldset'>
                            {!isDisabled && (
                                <div className='o-fieldset__row action-wrapper'>
                                    <button
                                        className='c-btn'
                                        type='button'
                                        onClick={() => {
                                            handlerSubmit();
                                        }}
                                        disabled={!isFormValid}
                                    >
                                        <span className='c-btn__text'>
                                            {t(CREDIT_APP_BUTTON_CONTINUE)}
                                        </span>
                                    </button>
                                </div>
                            )}
                            {isDisabled && (
                                <div className='o-fieldset__row'>
                                    <button
                                        className='c-btn c-btn--secondary'
                                        type='button'
                                        onClick={onEdit}
                                    >
                                        <span className='c-btn__text'>
                                            {t(
                                                PAYMENT_INFORMATION_DETAILS_BUTTONS_EDIT,
                                            )}
                                        </span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default FormSectionPage;
